import { render, staticRenderFns } from "./RichHtml.vue?vue&type=template&id=6141c9e5&"
import script from "./RichHtml.vue?vue&type=script&lang=js&"
export * from "./RichHtml.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports